import React, { useContext, useState } from "react";
import {
  AuthModel,
  PaymentContext,
  PaymentContextValue,
  PaymentStage,
} from "../../contexts/Payment/payment.context";
import PinInput from "../pin-input";
import { authorizeCharge, generateKey } from "../../services/api.services";
import { PinLoaderCircle } from "../button";
import { useViewContext } from "../../contexts/view.context";
import { usePayDataContext } from "../../contexts/PayDataContext";

export default function CardPin() {
  const {
    state,
    setState,
    setStage,
    setError,
    setPaymentReference,
  }: PaymentContextValue = useContext(PaymentContext);
  const { payReference, randomKey, merchantData } = usePayDataContext();
  const [loading, setLoading] = useState(false);
  const { checkoutSettings } = state.business || {};
  const { view, setView } = useViewContext();

  var CryptoJS = require("crypto-js");

  const handleEncryption = async (rawData: string): Promise<string> => {
    const encryptionKey = await generateKey(randomKey);
    var key = atob(encryptionKey);
    rawData = CryptoJS.enc.Utf8.parse(rawData);
    const utf8key = CryptoJS.enc.Utf8.parse(key);
    var encrypted = CryptoJS.AES.encrypt(rawData, utf8key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    const encryptedPayload = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    return encryptedPayload;
  };

  const handlePinSubmission = async (pin) => {
    setLoading(true);
    setState({ card: { ...state.card, pin } });
    try {
      const encryptedPin = await handleEncryption(JSON.stringify({ pin }));
      const payload = {
        pin: encryptedPin,
        reference: `${payReference}.${randomKey}`,
        transaction_reference: state.charge.reference,
      };
      const charge = await authorizeCharge(payload);

      const { auth_model, status, message } = charge;
      let stage;
      if (status === "send_otp") {
        setView("otp");
        return;
      } else if (status === "Successful") {
        setPaymentReference(charge.reference);
        setView("success");
        window.parent.postMessage(
          {
            action: "successful",
            data: {
              status: true,
              message: "Transaction was successful.",
              data: {
                status: "successful",
                reference: charge.reference,
              },
            },
          },
          "*"
        );

        if (merchantData.meta.redirect_url) {
          setTimeout(() => {
            window.location.href = merchantData.meta.redirect_url;
          }, 2000);
        }
        return;
      } else if (status === "Failed") {
        setError(message);
        setStage(PaymentStage.failed);
        setLoading(false);
        setView("error");
        return;
      }
      setError(null);
      switch (auth_model) {
        case AuthModel.PIN:
          stage = PaymentStage.failed;
          setError("Invalid PIN");
          return true;
        case AuthModel.OTP:
          stage = PaymentStage.auth_otp;
          break;
        case AuthModel["3DS"]:
          stage = PaymentStage.auth_threeds;
          break;
        case AuthModel.CARD_ENROLL:
          stage = PaymentStage.card_enroll;
          break;
        case AuthModel.BIRTHDAY:
          stage = PaymentStage.auth_dob;
          break;
        case AuthModel.PHONE:
          stage = PaymentStage.card_enroll;
          break;
        case AuthModel.AVS:
          stage = PaymentStage.avs;
          break;
        default:
          stage = PaymentStage.init;
          break;
      }
      setStage(stage);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      return;
    }
  };

  return (
    <div
      className={
        "space-y-8 flex flex-col justify-center sm:justify-start sm:py-12 py-4 items-center h-full sm:h-72"
      }
    >
      <div className="authorizeView p-3">
        <p className="text-center mb-5">
          Please enter your 4-digit card pin to
          <br />
          authorize this payment
        </p>

        <>
          {loading ? (
            <div className="w-full h-full flex items-center justify-center	">
              <PinLoaderCircle />
            </div>
          ) : (
            <PinInput
              length={4}
              autoFocus
              onChange={handlePinSubmission}
              hidden
            />
          )}
        </>
      </div>
    </div>
  );
}
